var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarnetTextIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 76,
    viewBox: "0 0 87 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1686 0.880005H17.9735C8.04702 0.880005 0 8.42424 0 17.7305V59.0716C0 68.3779 8.04702 75.9221 17.9735 75.9221H68.1686C78.0951 75.9221 86.1422 68.3779 86.1422 59.0716V17.7305C86.1422 8.42424 78.0951 0.880005 68.1686 0.880005Z",
    fill: "#95C3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3287 46H15V49.5828H71.3287V46Z",
    fill: "#AED3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3287 56.5193H15V60.1021H71.3287V56.5193Z",
    fill: "#AED3FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarnetTextIcon);
export default __webpack_public_path__ + "static/media/CarnetTextIcon.26c69a2e4af30c41136dc9426df3109a.svg";
export { ForwardRef as ReactComponent };